import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { Brand, BrandService } from './core/brand';

export class MultiTranslateHttpLoader implements TranslateLoader {
  private brand = Brand.SKRILL_AND_NETELLER;

  constructor(private brandService: BrandService) {
    this.brandService.brand.subscribe((brand) => {
      this.brand = brand;
    });
  }

  /**
   * Gets the translations from the server
   * @param lang
   * @returns {any}
   */
  public getTranslation(lang: string): any {
    // TODO maybe there is a better way to define the brands and avoid this replace?
    const brand = this.brand.replace(new RegExp('_', 'g'), '-');
    // TODO We don't need the forkJoin for now, b ecause we are importing only one translation at a time
    return forkJoin([from(import(`../assets/${brand}/i18n/${lang}.json`).then((res) => res.default))]).pipe(
      map((response) => response.reduce((a, b) => Object.assign({}, a, b)))
    );
  }
}

export function TranslateLoaderFactory(brandService: BrandService) {
  return new MultiTranslateHttpLoader(brandService);
}
